import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader, MainContentSection } from "components/shared/containers/MainContentContainer";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UIDatePicker from "components/ui/UIDatePicker ";
import React from "react";

import "./styles.css";
/**
 * @function EditTravelPlansPage
 * @return {React.Component}
 * @exported true
 * @description The main component for EditTravelPlansPage
 */

export default function EditTravelPlansPage(props) {
  return (
    <MainContentContainer header={<MainContentHeader text="Edit Travel Plan" />}>
      <FormContainer>
        <MainContentSection text="Traveling to">
          <FormRow>
            {/* UIDestinationSelect */}
          </FormRow>
        </MainContentSection>     
        <MainContentSection text="Travel Dates">
          <FormRow>
            <UIDatePicker />
          </FormRow>
          <FormRow>
            <UIDatePicker />
          </FormRow>
          <FormRow>
            <p>Your Travel Plan will be recorded in Eastern Time.</p>
          </FormRow>
          <FormButtonContainer>
            <UIPrimaryButton text="Submit" />
            <UICancelButton text="Cancel" />
          </FormButtonContainer>
        </MainContentSection>
      </FormContainer>
    </MainContentContainer>
  );
}